export const WEEK_DAYS = ['LUNDI', 'MARDI', 'MERCREDI', 'JEUDI', 'VENDREDI', 'SAMEDI', 'DIMANCHE'];


// WEBPACK FOOTER //
// ./src/constants/weekDays.js